import { SolutionContextProvider } from '@datacamp/input-fields';
import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const defaultContext = {
  hasSolution: false,
  solutionShown: 0
};
export const ProvidedSolutionContext = _ref => {
  let {
    children,
    exercise,
    solutionShown
  } = _ref;
  let context = defaultContext;
  if (exercise != null) {
    context = {
      hasSolution: exercise.question.flavor === 'Open',
      solutionShown: solutionShown ? 1 : 0
    };
  }
  return ___EmotionJSX(SolutionContextProvider, {
    context: context
  }, children);
};